module.exports = __webpack_public_path__ + "img/16581273_L.70acbbe5.png";